import { AUDIT_LOGS_HEADERS } from '@src/constants/AuditLogs';

/**
 * function to get all the audit headers required
 * @param {Object} data data object
 * @param {Object} data.domain contains information related to domains
 * @param {string} data.domain.title title of the domain
 * @param {string} data.domain.client name of the client linked with domain
 * @param {string} data.eventName Name of the event to send
 * @return headers object containing all the headers required for audit logs
 */
// eslint-disable-next-line import/prefer-default-export
export const getAuditHeaders = ({ domain, eventName }) => {
  let headers = { ...AUDIT_LOGS_HEADERS };

  try {
    headers = {
      ...headers,
      'x-haptik-bot-name': domain.title,
      'x-haptik-partner-name': domain.client,
    };

    if (eventName) {
      headers = {
        ...headers,
        'x-haptik-event-type': eventName,
      };
    }
  } catch (e) {
    // TODO: Modify BOLE so that we can send audit errors to sentry without showing alert
    console.warn('Unable to set audit headers', e);
  }

  return headers;
};
